import recorder from '../recorder.js';
import Tone from 'tone';
import {getMilliseconds} from './getMilliseconds.js';
import {setIsResampling} from 'actions/index.js';
import SoundUploader from 'api/SoundUploader.js';
import Sample from 'repos/Sample.js';

const DELAY = 500;
const BUFFER_TIME_LENGTH = 10000;

class SimpleResampler {
    constructor() {
        this.isRecording = false;
    }

    // need to constantly record and a buffer
    set input(input) {
        if (input === undefined) {
            this.recorder.clear();
            this.recorder.stop();
            this.recorder = undefined;
            this.isRecording = false;
            return;
        }
        this.recorder = new window.Recorder(input, {numChannels: 2, bufferLen: 512*2});
        this.recorder.record(new Date().getTime());
        this.startRecordLoop();
    }

    async startRecordLoop() {
        console.log('start record loop');
        while (this.recorder !== undefined) {
            await this.sleep(BUFFER_TIME_LENGTH);
            if (!this.isRecording) {
                console.log('clearing');
                this.recorder.clear();
            }
        }
    }

    sleep(time) {
        return new Promise(async (resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

    start(time=0) {
        this.recorder.clear();
        this.isRecording = true;
    }

    stop(time=0) {
        return new Promise(async (resolve, reject) => {
            await this.sleep(time);
            this.recorder.getBuffer((blob) => {
                let sample = this.getSample(blob);
                this.recorder.clear();
                this.isRecording = false;
                resolve(sample);
            });
        });
    }
    
    getSample(blob) {
        let frameCount = blob[0].length;
        let audioBuffer = Tone.Master.context.createBuffer(2, frameCount, Tone.Master.context.sampleRate);  
        audioBuffer.copyToChannel(blob[0], 0, 0);
        audioBuffer.copyToChannel(blob[1], 1, 0);
        let sample = new Sample();
        sample.audioBuffer = audioBuffer;
        return sample;
    }

}

export default SimpleResampler;
